import { render } from "./DashboardSettings.vue?vue&type=template&id=6e68bd1a"
import script from "./DashboardSettings.vue?vue&type=script&lang=js"
export * from "./DashboardSettings.vue?vue&type=script&lang=js"

import "./DashboardSettings.vue?vue&type=style&index=0&id=6e68bd1a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__